import React, { useEffect, useState } from 'react';
import '../../../index.scss';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import { isType3, userTypeList } from 'main_consts';

// material
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  checkboxChange,
  formatDateTime,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';
import CheckBox from '../../../components/Material/Checkbox';
import { IhawbStat, ImawbStat, Iobject } from '../../../main_type';
import { Imaster } from './type';

const DivStyle = styled.div`
  border: 3px outset #1c6ea4;
  margin-bottom: 1rem;
`;

/** 主提單貨物統計資料查詢 */
const MawbStatQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 進出口別
    declType: '1',
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 主號
    mawbNo: '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    // 是否加入時間查詢
    timeCheck: '0',
    // 報單號碼
    declNo: '',
    // 報單類別
    appType: '',
    endDateValid: true,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
  };

  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [mawbStat, setMawbStat] = useState<ImawbStat>({} as ImawbStat);
  const [hawbStat, setHawbStat] = useState<IhawbStat>({} as IhawbStat);
  const [submitKey, setSubmitKey] = useState('search');

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const result = await getExcel('mawbStatQry', {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      declNo: master.declNo,
      appType: master.appType,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    const startDate = formatDateTime(
      master.startDate,
      master.startTime,
      'MMdd'
    );
    const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master.chkCode1.length > 0 ? `${master.chkCode1}_` : ''
      }${startDate}_${EndDate}_主提單貨物統計資料查詢.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch('mawbStatQry', {
      chkCode1: master.chkCode1,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      declNo: master.declNo,
      appType: master.appType,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data } = result.data;
    if (data) {
      const { mawbStat: mawbStatTemp, hawbStat: hawbStatTemp } = data as {
        mawbStat: ImawbStat;
        hawbStat: IhawbStat;
      };
      if (mawbStatTemp) {
        setMawbStat(mawbStatTemp);
        setOpenSearchTable(true);
      }
      if (hawbStatTemp) {
        setHawbStat(hawbStatTemp);
        setOpenSearchTable(true);
      }
    } else {
      setOpenSearchTable(false);
    }
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setMawbStat({} as ImawbStat);
    setHawbStat({} as IhawbStat);
    setFormError(false);
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">主提單貨物統計資料查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 主提單貨物統計資料查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <HVcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio "
                required
                name="declType"
                value={master.declType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </HVcGrid>
          </Grid>
          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={2}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                進倉日期區間：
              </VcEGrid>
              <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
                <DateTimeSePickersTyping
                  key={random}
                  required={master.timeCheck === '1'}
                  disabled={master.timeCheck === '0'}
                  updateData={updateData}
                  style={{ maxWidth: 800 }}
                  names={[
                    ['startDate', 'startTime'],
                    ['endDate', 'endTime'],
                  ]}
                  data={master}
                  setDayRange={3}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={2}>
                <CheckBox
                  label="加入時間查詢"
                  checked={master.timeCheck === '1'}
                  name="timeCheck"
                  onChange={(e) => {
                    setMaster((prev) => ({
                      ...prev,
                      startDate: masterDefaultValue.startDate,
                      startTime: masterDefaultValue.startTime,
                      endDate: masterDefaultValue.endDate,
                      endTime: masterDefaultValue.endTime,
                      ...checkboxChange()(['1', '0'])(e),
                    }));
                  }}
                />
              </VcGrid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*主號：</FormTitle>
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  required
                  maxLength={35}
                  value={master.mawbNo}
                  name="mawbNo"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                報單號碼：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  maxLength={14}
                  value={master.declNo}
                  name="declNo"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                報單類別：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  maxLength={2}
                  value={master.appType}
                  name="appType"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <DivStyle>
          <Grid container>
            <VcEGrid item xs={4} sm={1}>
              主號：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {mawbStat.mwbCnt} 筆
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              申報總重量：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {mawbStat.totalWeight} Kg
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              進倉總重量：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {mawbStat.totalGciWeight} Kg
            </VcGrid>
          </Grid>
          <Divider />
          <Grid container>
            <VcEGrid item xs={4} sm={1}>
              分號：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {hawbStat.hwbCnt} 筆
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              申報：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {hawbStat.piece} 件
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              進倉：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {hawbStat.gciPiece} 件
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              出倉：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {hawbStat.gcoPiece} 件
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              申報重量：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {hawbStat.weight} Kg
            </VcGrid>
            <VcEGrid item xs={4} sm={1}>
              進倉重量：
            </VcEGrid>
            <VcGrid item xs={8} sm={1}>
              {hawbStat.gciWeight} Kg
            </VcGrid>
          </Grid>
        </DivStyle>
      )}
    </div>
  );
};

export default MawbStatQry;
